(function () {
    'use strict';

    angular
        .module('franchisee-portal.filters')
        .filter('cnpj', formatCNPJ)

    function formatCNPJ() {
        return input => {
            let string = input + '';

            if (string.length == 14)
                return string.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");

            return string;
        }
    }
}());